import React, { useState, useEffect, useRef } from "react";
import ReactInputMask from "react-input-mask";
import axios from "axios";
import { api } from "@/services/api";
import ModalPopup from "@/components/ModalPopup";
import { Shimmer as DivShimmer } from "@/components/Shimmer";

import { Container, ContainerMap, ShimmerEffect } from "./styles";

export const Strores = () => {
	const mapCanvas = useRef(null);
	const [loadApiGoogle, setLoadApiGoole] = useState(false);
	const [loadData, setLoadData] = useState(false);

	const [storeType, setStoreType] = useState(1);
	const [findStoreType, setFindStoreType] = useState(1);
	const [cep, setCep] = useState("");
	const [city, setCity] = useState("");
	const [address, setAddress] = useState("");

	const [places, setPlaces] = useState([]);

	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});

	const [digitalStores, setDigitalStores] = useState(null);
	const loadElements = [];

	for (let index = 0; index < 4; index++) {
		loadElements.push(index);
	}

	useEffect(() => {
		const CancelToken = axios.CancelToken; // instância do CancelToken
		const source = CancelToken.source(); // instância do source, onde está contido o token de cancelamento

		const loadData = () => {
			api.get("merchant/list/digital")
				.then((res) => {
					setDigitalStores(res?.data?.list);
				})
				.catch((error) =>
					console.warn({ endPoin: "merchant/list/digital", error }),
				);
		};

		loadData();

		// retorna uma função com a finalidade fazer o cancelamento
		return () => {
			source.cancel();
		};
	}, []);

	// carregando blibioteca do google maps
	useEffect(() => {
		const script = document.createElement("script");

		script.src = `https://maps.googleapis.com/maps/api/js?sensor=false&key=${process.env.REACT_APP_GOOGLE_KEY}`;
		script.async = true;

		document?.head?.appendChild(script);
		script?.addEventListener("load", () => {
			setLoadApiGoole(true);
		});

		return () => {
			document?.head?.removeChild(script);
			document?.head?.querySelectorAll("script")?.forEach((el, index) => {
				let scriptSource = el?.getAttribute("src");
				if (scriptSource?.match(/maps.googleapis/g)) {
					el?.remove();
				}
			});
		};
	}, []);

	// carregando mapa
	useEffect(() => {
		if (mapCanvas && loadApiGoogle && places) {
			renderPoints(places);
		}
	}, [mapCanvas, loadApiGoogle, places]);

	function handleSearchType(data) {
		if (data === cep) {
			const value = data;
			const valueCharacters = value.replace(/[-_.]/g, "").length;
			if (valueCharacters === 8) {
				handleGetStores(data);
			}
		} else {
			handleGetStores(data);
		}
	}

	// ao cep esta completo
	// useEffect(() => {
	// 	const value = cep;
	// 	const valueCharacters = value.replace(/[-_.]/g, "").length;
	// 	if (valueCharacters === 8) {
	// 		handleGetStores({ cep });
	// 	}
	// }, [cep]);

	// pegando lista de lojas
	function handleGetStores(data) {
		setLoadData(true);

		api.get("merchant/list/stores", {
			params: data,
		})
			.then((res) => {
				if (res.data.status === 500) {
					setModalPopup(true);
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});
				}

				if (res.data.status === 200) {
					setPlaces(res.data.list);
				}
			})
			.catch((error) => {
				console.error({ endPoint: "merchant/list/stores", error });
			})
			.finally(() => {
				setLoadData(false);
			});
	}

	// funcao para redenrizar pontos
	function renderPoints(locations, defaultZoom = true) {
		if (locations.length > 0) {
			const google = window.google;
			const map = new google.maps.Map(mapCanvas.current, {
				zoom: defaultZoom ? 6 : 10,
				center: {
					lat: parseFloat(locations[0].localization.lat),
					lng: parseFloat(locations[0].localization.lng),
				},
			});

			locations.forEach((e) => {
				const marker = new google.maps.Marker({
					position: {
						lat: parseFloat(e.localization.lat),
						lng: parseFloat(e.localization.lng),
					},
					map,
					title: e.infoTitle,
					icon: `${
						require("@/assets/img/Icon-feather-map-pin.svg").default
					}`,
				});

				const infowindow = new google.maps.InfoWindow({
					content: `<div id="content"> 
                            <div id="bodyContent"> 
                                <p style="font-family: "Montserrat", sans-serif;">
                                    <strong class="h6">${e.store}</strong>
                                </p>
								<p>${e.localization.address} ${e.localization.number}, 
								${e.localization.district !== null ? (e.localization.district + " - ") : "" } ${e.localization.city}
								</p>
                                <p>Telefone: ${e.phone}</p>
                            </div> 
                        </div>`,
					maxWidth: 300,
				});

				if (!defaultZoom) {
					infowindow.open(map, marker);
				} else {
					marker.addListener("click", () => {
						infowindow.open(map, marker);
					});
				}
			});
		}
	}

	// funcao para pegar local do usaurio
	function geoLocation() {
		if ("geolocation" in navigator) {
			navigator.geolocation.getCurrentPosition(
				(data) => {
					handleGetStores({
						lat: data.coords.latitude,
						lng: data.coords.longitude,
					});
				},
				(error) => {
					console.log(error);
				},
			);
		} else {
			setModalPopup(true);
			setModalContent({
				title: "Programa Fidelidade GERIOOX",
				content:
					"Sinto muito, mas os serviços de geolocalização não são compatíveis com seu navegador.",
			});
		}
	}

	function handleZoomPoit(index) {
		renderPoints([places[index]], false);
	}

	return (
		<Container>
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(!modalPopup)}
			/>
			<header>
				<h2>Lojas participantes</h2>

				<div className='btns-group'>
					<button
						className={
							storeType === 1
								? "btn-stores active "
								: "btn-stores"
						}
						onClick={() => setStoreType(1)}>
						Lojas físicas
					</button>
					<button
						className={
							storeType === 2
								? "btn-stores active "
								: "btn-stores"
						}
						onClick={() => setStoreType(2)}>
						Lojas online
					</button>
				</div>

				{storeType === 1 && (
					<div>
						<div 
							className='btns-group '
							style={{margin: "30px 10px"}}
						>
							<button
								className={
									findStoreType === 1
										? "btn-stores active "
										: "btn-stores"
								}
								onClick={() => setFindStoreType(1)}>
								CEP
							</button>
							<button
								className={
									findStoreType === 2
										? "btn-stores active "
										: "btn-stores"
								}
								onClick={() => setFindStoreType(2)}>
								Cidade
							</button>
							<button
								className={
									findStoreType === 3
										? "btn-stores active "
										: "btn-stores"
								}
								onClick={() => setFindStoreType(3)}>
								Endereço
							</button>
						</div>
						{findStoreType === 1 && (
							<div>
								<p>
									Digite seu CEP no espaço abaixo e navegue no mapa,
									para encontrar uma loja participante mais próxima de
									você.
								</p>
								<div className='form'>
									<div className='search'>
										<ReactInputMask
											mask='99999-999'
											type='text'
											placeholder='00000-000'
											value={cep}
											onChange={(e) => setCep(e.target.value)}
										/>
										<img
											loading='lazy'
											src={
												require("@/assets/img/Icon feather-search.svg")
													.default
											}
											alt='icone busca'
											onClick={() => handleSearchType({cep})}
										/>
									</div>
									<a href="//buscacepinter.correios.com.br/app/endereco/index.php?t" target="_blank" rel="noopener noreferrer" className='d-none d-lg-block'>
										Não sei o CEP
									</a>
									{places && places.length > 0 && (
										<span className='d-lg-none'>
											Exibindo <strong>{places.length}</strong>{" "}
											lojas próxima nessa área.
										</span>
									)}
								</div>
								<div className='desktop-list d-none d-lg-block'>
									{places && places.length > 0 && (
										<p>
											Exibindo <strong>{places.length}</strong>{" "}
											lojas próxima nessa área.
										</p>
									)}
									<ul className='stores-list'>
										{places?.map((local, index) => (
											<li
												key={index}
												data-target={`place-${index}`}
												onClick={() => handleZoomPoit(index)}>
												<address>
													<h2>{local.store}</h2>
													<p>
														{local.localization.address},{" "}
														{local.localization.number}
														{local.localization.district && (" - " + local.localization.district)},{" "}
														{local.localization.city} - CEP{" "}
														{local.localization.zip_code}
													</p>
													<p>Tel: {local.phone}</p>
												</address>
											</li>
										))}
									</ul>
								</div>
							</div>
						)}
						{findStoreType === 2 && (
							<div>
								<p>
									Digite sua cidade no espaço abaixo e navegue no mapa,
									para encontrar uma loja participante mais próxima de
									você.
								</p>
								<div className='form'>
									<div className='search'>
										<ReactInputMask
											mask=''
											type='text'
											placeholder='São Paulo'
											value={city}
											onChange={(e) => setCity(e.target.value)}
										/>
										<img
											loading='lazy'
											src={
												require("@/assets/img/Icon feather-search.svg")
													.default
											}
											alt='icone busca'
											onClick={() => handleSearchType({city})}
										/>
									</div>
									{places && places.length > 0 && (
										<span className='d-lg-none'>
											Exibindo <strong>{places.length}</strong>{" "}
											lojas próxima nessa área.
										</span>
									)}
								</div>
								<div className='desktop-list d-none d-lg-block'>
									{places && places.length > 0 && (
										<p>
											Exibindo <strong>{places.length}</strong>{" "}
											lojas próxima nessa área.
										</p>
									)}
									<ul className='stores-list'>
										{places?.map((local, index) => (
											<li
												key={index}
												data-target={`place-${index}`}
												onClick={() => handleZoomPoit(index)}>
												<address>
													<h2>{local.store}</h2>
													<p>
														{local.localization.address},{" "}
														{local.localization.number}
														{local.localization.district && (" - " + local.localization.district)},{" "}
														{local.localization.city} - CEP{" "}
														{local.localization.zip_code}
													</p>
													<p>Tel: {local.phone}</p>
												</address>
											</li>
										))}
									</ul>
								</div>
							</div>
						)}
						{findStoreType === 3 && (
							<div>
								<p>
									Digite seu endereço no espaço abaixo e navegue no mapa,
									para encontrar uma loja participante mais próxima de
									você.
								</p>
								<div className='form'>
									<div className='search'>
										<ReactInputMask
											mask=''
											type='text'
											placeholder='Rua Alfredo Pujol, 379'
											value={address}
											onChange={(e) => setAddress(e.target.value)}
										/>
										<img
											loading='lazy'
											src={
												require("@/assets/img/Icon feather-search.svg")
													.default
											}
											alt='icone busca'
											onClick={() => handleSearchType({address})}
										/>
									</div>
									{places && places.length > 0 && (
										<span className='d-lg-none'>
											Exibindo <strong>{places.length}</strong>{" "}
											lojas próxima nessa área.
										</span>
									)}
								</div>
								<div className='desktop-list d-none d-lg-block'>
									{places && places.length > 0 && (
										<p>
											Exibindo <strong>{places.length}</strong>{" "}
											lojas próxima nessa área.
										</p>
									)}
									<ul className='stores-list'>
										{places?.map((local, index) => (
											<li
												key={index}
												data-target={`place-${index}`}
												onClick={() => handleZoomPoit(index)}>
												<address>
													<h2>{local.store}</h2>
													<p>
														{local.localization.address},{" "}
														{local.localization.number}
														{local.localization.district && (" - " + local.localization.district)},{" "}
														{local.localization.city} - CEP{" "}
														{local.localization.zip_code}
													</p>
													<p>Tel: {local.phone}</p>
												</address>
											</li>
										))}
									</ul>
								</div>
							</div>
						)}

					</div>
				)}
				{storeType === 2 && (
					<div>
						<p className='text-content'>
							Atendimento para todo brasil
						</p>
					</div>
				)}
			</header>
			<div className='content'>
				<div
					className='box'
					style={{
						display: storeType === 1 ? "block" : "none",
					}}>
					{loadData === false && places.length === 0 && (
						<ContainerMap>
							<img
								loading='lazy'
								src={
									require("@/assets/img/mapCapa.jpg").default
								}
								alt='map'
							/>
							<button onClick={() => geoLocation()}>
								Usar minha localizacao
							</button>
						</ContainerMap>
					)}
					{loadData === true && places.length === 0 && (
						<ShimmerEffect />
					)}
					{places.length > 0 && (
						<div
							ref={mapCanvas}
							id='map-canvas'
							style={{ height: "100%", width: "100%" }}></div>
					)}
				</div>

				<div
					className='box'
					style={{
						display: storeType === 2 ? "block" : "none",
					}}>
					<div className='digitalStores'>
						{digitalStores
							? digitalStores.map((store, index) => (
									<div key={index} className='store'>
										<img
											loading='lazy'
											className='store__image'
											src={`${process.env.REACT_APP_URL_STORE}/${store.photo}`}
											alt={store.store}
										/>
										<div className='store-content'>
											<h3 className='store-content__title'>
												{store.store}
											</h3>
											<a
												className='store-content__link'
												href={store.website}
												target='_blank'
												rel='noopener noreferrer'>
												comprar
											</a>
										</div>
									</div>
							  ))
							: loadElements.map((_, index) => (
									<div key={index} className='col store'>
										<DivShimmer
											width={80}
											height={80}
											border={0}
										/>
										<div className='store-content'>
											<DivShimmer
												width={80}
												height={21}
											/>
											<DivShimmer
												width={130}
												height={38}
											/>
										</div>
									</div>
							  ))}
					</div>
				</div>
			</div>
		</Container>
	);
};

export default Strores;
